import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { cases, categories } from "@/mocks/cases";

export default function CategorySection() {
  const items = categories.filter((c) => c.id !== "all");

  return (
    <section id="category" className="w-full px-4 md:px-8 py-14 md:py-20">
      <SectionHeading
        eyebrow="Topics"
        title="按主题翻档案"
        desc="同一个事件往往横跨多个维度。我们按「行程时间线 / 商业内幕 / 合约风波 / 圈内口碑」四类归档，方便你从熟悉的切口进入。"
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {items.map((cat, index) => {
          const count = cases.filter((c) => c.category === cat.id).length;
          return (
            <Link
              key={cat.id}
              to={`/archive?cat=${cat.id}`}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-6 transition-colors hover:border-primary-300 hover:bg-primary-50 cursor-pointer"
            >
              <span className="font-heading text-3xl font-bold text-background-400 group-hover:text-primary-300 transition-colors">
                0{index + 1}
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{cat.name}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600 flex-1">{cat.intro}</p>
              <span className="mt-6 flex items-center justify-between text-xs text-foreground-500">
                <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-900">
                  {count} 条档案
                </span>
                <i className="ri-arrow-right-up-line text-base text-primary-600 group-hover:translate-x-0.5 transition-transform" />
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}